import React from 'react';
import { Outlet } from 'react-router';

const WithoutBottomNav = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default WithoutBottomNav;